export default __webpack_public_path__ + "static/media/songwriter_benefits_2.ae556b23.svg";